export default __webpack_public_path__ + "static/media/save_caution_matte_white.36239be1.svg";